
import { mapState } from 'vuex'
import LayoutContainer from '@/components/globals/LayoutContainer'
import * as animationData from '~/assets/lottie/loader.json'

export default {
  name: 'MinimalLayout',
  components: {
    LayoutContainer
  },
  computed: {
    ...mapState(['loading', 'errors']),
    lottieData() {
      return animationData.default
    }
  },
}
